export default "__VITE_ASSET__agCjX6T8__"